import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { 
  // Badge, 
  DropdownItem, 
  DropdownMenu, 
  DropdownToggle, 
  Nav, 
  NavItem, 
  // NavLink, 
  // Button, 
  UncontrolledDropdown
} from 'reactstrap';

import PropTypes from 'prop-types';
import Helper from '../../services/Helper'

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarMinimizer, AppSidebarToggler } from '@coreui/react';

// import logo from '../../assets/img/brand/astra-international.png'
// import sygnet from '../../assets/img/brand/sygnet.svg'

/* 
* for Logo
<AppNavbarBrand
    full={{ src: logo, tag:'asdf', width: 145, alt: 'Astra International Logo' }}
    minimized={{ src: logo, tag:'asdf', width: 200, alt: 'Astra International Logo' }}
/>

*/

class Header extends Component {

    state = {
      formData: ''
    }

    toggleClick() {
        /* let el = document.getElementById('toggleSidebar') 
        el.click() */
    }

    logout(e) {
        localStorage.removeItem('token')
        return window.location = '/astra/#/login'
    }
    profile(e) {
        return window.location = '/astra/#/profile'
    }

    componentDidMount() {
        let icon = document.getElementsByClassName('navbar-toggler-icon')[0]
        icon.style.display = 'none'
        let formData = Helper.getUser()
        this.setState({
          formData,
        })
    }

    render() {
      const {
        formData
      } = this.state
      return ( 
        <React.Fragment>
            <AppSidebarToggler className="sidebar-minimizer mt-auto d-lg-none d-md-block d-sm-block d-block" id="toggleSidebar" mobile /> 
            <AppSidebarMinimizer /> 
          <div className="mr-auto" style={{color: '#fff',fontSize: '20px', marginLeft:'10px'}}>
              <span style={{
                  fontWeight:'bold'
              }}>
                  ASTRA
              </span> international
          </div>
          
          <Nav className="ml-auto mr-3" navbar> 
            {
              //<AppHeaderDropdown direction="down">
               //  <DropdownToggle nav>
               //    <i className="icon-bell header__bell-o"></i> 
               //  </DropdownToggle> 
               //  <DropdownMenu className="header__dropdown">
               //    <DropdownItem header tag="div" className="text-center dropdown-header"><strong>You have 5 notifications</strong></DropdownItem>
               //    <DropdownItem>
               //      <i className="icon-user-unfollow text-danger"></i> 
               //      <div>There is new event, with the name "Agen Seminar". Click to see details<br />
               //        <span>12 minutes ago</span> 
               //      </div> 
               //    </DropdownItem>  
               //  </DropdownMenu>

               // </AppHeaderDropdown> 
                  }
                  
            

                  <AppHeaderDropdown direction="down">
                    <UncontrolledDropdown>
                        <DropdownToggle style={{
                            color:'#fff',
                            fontWeight:'800'
                        }} className="d-xs-down-none" nav>
                              <img src={'/assets/img/avatars/9.jpeg'} className="img-avatar" alt="icon user" />   
                              <span className="d-sm-down-none" >  Halo {this.props.username} &nbsp;  ({formData.roleId === 1 ? "Admin Pusat" : 
                                formData.roleId === 2 ? "Admin Perusahaan" : 
                                formData.roleId === 3 ? "Pimpinan Instalasi":
                                formData.roleId === 4 ? "Management Astra":
                                formData.roleId === 5 ? "Pic Instalasi":
                                formData.roleId === 6 ? "Asessor":
                                formData.roleId === 7 ? "Kepala Perusahaan" : ''
                                })</span>
                              <i style={{marginLeft: "6px"}} className="fa fa-ellipsis-v" aria-hidden="true"></i>  
                        </DropdownToggle>
                        <DropdownMenu className="header-profil__header dropdown-menu-right"> 
                            <DropdownItem className="text-center" onClick={this.profile}><i className="fa fa-user" aria-hidden="true"></i> My Profile</DropdownItem>
                            <DropdownItem className="text-center" onClick={this.logout}><i className="fa fa-power-off" aria-hidden></i> Logout</DropdownItem>                 
                        </DropdownMenu>
                    </UncontrolledDropdown>
                
            </AppHeaderDropdown>
                                
          </Nav>              
        </React.Fragment>
      );
    }
}


export default Header;